import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles( (theme) => ({
    radioGroup: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginRight: '-3px', // offset the overlapping borders to re-center
      marginTop: '3px', // offset the overlapping borders to re-center
    },
    radioLabel: {
      margin: 0,
      border: '3px solid ' + theme.palette.red,
      color: '#fff',
      textTransform: 'uppercase',
      padding: '4px 4rem',
      background: theme.palette.navyDark3,
      transition: '.1s all',
      marginLeft: '-3px', // overlap borders (not wrapping)
      marginTop: '-3px', // overlap borders (wrapping)
      flexShrink: 1,
      flex: (props) => ( props.width === "auto" ? "0 0 auto" : "0 0 23.5rem"),
      '&:hover': {
        background: theme.palette.red,
      },
      '&.active': {
        background: theme.palette.redDark,
      },
      '& .MuiFormControlLabel-label': {
        fontFamily: 'Vox',
        fontSize: '2.1rem',
        lineHeight: '2.1rem',
        letterSpacing: '.06em',
        fontWeight: 700,
        paddingLeft: '1rem',
      },
    },
    icon: {
      height: '2.8rem',
      width: '2.8rem',
      border: '#FFF 2px solid',
      borderRadius: '50%',
    },
    checkedIcon: {
      borderWidth: 7,
      background: theme.palette.red
    },
    footerComponentWrapper: {
      display: 'flex',
    }
}));

export const RadioToggle = ({ hideLabel, label, options, name, setValue, value, width }) => {
    const classes = useStyles({width})

    const handleChange = (e) => {
        setValue(e.target.value);
    }

    return (
        <fieldset>
            
            <legend className={`lang__label${hideLabel ? " sr-only" : ""}`}>{label}</legend>

            <RadioGroup
                className={classes.radioGroup} 
                aria-label={name} 
                name={name} 
                value={value} 
                onChange={handleChange}
            >
                {options.map((option, i)=> (
                    <FormControlLabel 
                        key={i}
                        className={`${classes.radioLabel} ${value === option.value ? 'active' : ''} `} 
                        value={option.value}
                        label={option.label}
                        control={
                            <Radio 
                                checkedIcon={<span className={classes.icon + ' ' + classes.checkedIcon} />}
                                icon={<span className={classes.icon} />}
                            />
                        } 
                    />  
                ))}
            </RadioGroup>

        </fieldset>)
}